import { EventConfig } from '@/types';

export enum EVENT {
  KNOW_HOW_TO_GET_BUTTON_VIEW = 'idverify.know_how_to_get_button.view',
  KNOW_HOW_TO_GET_BUTTON_CLICKED = 'idverify.know_how_to_get_button.clicked',
  START_REGISTRATION_BUTTON_CLICKED = 'idverify.start_registration_button.clicked',
  START_REGISTRATION_PAGE_VIEW = 'idverify.start_registration_page.view',
  QRCODE_PAGE_OPENED_VIEW = 'idverify.qrcode_page_opened_view.view',
  START_QRCODE_VIEW = 'idverify.start_qrcode.view',
  FIRST_STEP_ERROR_VIEW = 'idverify.first_step_error.view',
  START_FACIAL_RECOGNITION_PAGE_VIEW = 'idverify.start_facial_recognition_page.view',
  START_FIRST_STEP_BUTTON_CLICKED = 'idverify.start_first_step_button.clicked',
  NO_ACCESS_CAMERA_BUTTON_CLICKED = 'idverify.no_access_camera_button.clicked',
  CLOSE_MODAL_BUTTON_CLICKED = 'idverify.close_modal_button.clicked',
  DOCUMENTS_REGISTRATION_PAGE_VIEW = 'idverify.documents_registration_page.view',
  REGISTRATION_COMPLETED_SUCCESSFULLY_PAGE_VIEW = 'idverify.registration_completed_successfully_page.view',
  REGISTRATION_COMPLETED_SUCCESSFULLY_DESKTOP_PAGE_VIEW = 'idverify.registration_completed_successfully_desktop_page.view',
  CONSULT_DOCUMENT_ANALYSIS_PAGE_VIEW = 'idverify.consult_document_analysis_page.view',
  CONSULT_DOCUMENT_APPROVED_PAGE_VIEW = 'idverify.consult_document_approved_page.view',
  CONSULT_DOCUMENT_DECLINED_PAGE_VIEW = 'idverify.consult_document_declined_page.view',
  REGISTER_BANK_ACCOUNT_BUTTON_CLICKED = 'idverify.register_bank_account_button.clicked',
  REGISTER_DOCUMENTS_AGAIN_BUTTON_CLICKED = 'idverify.register_documents_again_button.clicked',
  INVALID_DOCUMENT_ERROR_PAGE_VIEW = 'idverify.invalid_document_error_page.view',
  TRY_AGAIN_BUTTON_CLICKED = 'idverify.try_again_button.clicked',
  FACIAL_RECOGNITION_SUCCESS_PAGE_VIEW = 'idverify.facial_recognition_success_page.view',
  DOCUMENT_SENT_SUCCESSFULLY_PAGE_VIEW = 'idverify.document_sent_successfully_page.view',
  LINK_OPEN_ON_MOBILE_CLICKED = 'idverify.link_open_on_mobile.click',
  TIME_EXPIRED_VIEW = 'idverify.time_expired.view',
  SESSION_EXPIRED_VIEW = 'idverify.session_expired_view.view',
  QRCODE_REGENERATED = 'idverify.qrcode_regenerated.view',
  FINISH_FLOW_REVIEW_SUCCESSFULLY_CLICK = 'idverify.finish_flow_review_successfully.click',
  FACE_RECOGNITION_ERROR = 'idverify.face_recognition.error',
  CAMERA_PERMISSION_ERROR = 'idverify.camera_permission.error',
  DOCUMENT_UPLOAD_ERROR = 'idverify.document_upload.error',
  NETWORK_ERROR = 'idverify.network.error',
  SDK_INITIALIZATION_ERROR = 'idverify.sdk_initialization.error',
  DOCUMENT_VALIDATION_ERROR = 'idverify.document_validation.error',
  FACE_LIVENESS_ERROR = 'idverify.face_liveness.error',
  DOCUMENT_QUALITY_ERROR = 'idverify.document_quality.error',
  NOTIFICATION_TRY_AGAIN_VIEW = 'idverify.notification_try_again.view',
  NOTIFICATION_OCR_ERROR_VIEW = 'idverify.notification_ocr_error.view',
  NOTIFICATION_AUTHORIZATION_VIEW = 'idverify.notification_authorization.view',
  NOTIFICATION_ERROR_RETRY_CLICK = 'idverify.notification_error_retry.click',
  SOCIAL_DOCUMENT_UPLOAD_BUTTON_CLICKED = 'idverify.social_document_upload_button.clicked',
  COMPANY_DOCUMENT_UPLOAD_BUTTON_CLICKED = 'idverify.company_document_upload_button.clicked',
  CNH_DOCUMENT_UPLOAD_BUTTON_CLICKED = 'idverify.cnh_document_upload_button.clicked',
  RG_DOCUMENT_UPLOAD_BUTTON_CLICKED = 'idverify.rg_document_upload_button.clicked',
  RNM_RNE_DOCUMENT_UPLOAD_BUTTON_CLICKED = 'idverify.rnm_rne_document_upload_button.clicked',
  PASSPORT_DOCUMENT_UPLOAD_BUTTON_CLICKED = 'idverify.passport_document_upload_button.clicked',
  DOCUMENT_UPLOAD_BUTTON_CLICKED = 'idverify.document_upload_button.clicked',
  SOCIAL_CONTRACT_PAGE_VIEW = 'idverify.social_contract_page.view',
  SAVE_AND_CONTINUE_LATER_BUTTON_CLICKED = 'idverify.save_and_continue_later_button.clicked',
  SAVE_AND_CONTINUE_LATER_BUTTON_CANCELLED_CLICKED = 'idverify.save_and_continue_later_button_cancelled.clicked',
  SAVE_AND_CONTINUE_LATER_BUTTON_CLICKED_PAGE_VIEW = 'idverify.save_and_continue_later_button_page.view',
  CONTINUE_BUTTON_CLICKED = 'idverify.continue_button.clicked',
  ADMINISTRATOR_PAGE_VIEW = 'idverify.administrator_page.view',
  ADMIN_SELECTED_BUTTON_CLICKED = 'idverify.admin_selected_button.clicked',
  PARTNERS_PAGE_VIEW = 'idverify.partners_page.view',
  ADMIN_TAG_HOVERED = 'idverify.admin_tag_hovered.view',
  PARTNERS_ADMIN_CONTAINER_CLICKED = 'idverify.partners_admin_conteiner.clicked',
  PARTNERS_DOCUMENTS_BUTTON_CLICKED = 'idverify.partners_documents_button.clicked',
  AVERAGE_REVENUE_PAGE_VIEW = 'idverify.average_revenue_page.view',
  AVERAGE_REVENUE_SELECTED_BUTTON_CLICKED = 'idverify.average_revenue_selected_button.clicked',
  AVERAGE_REVENUE_CONTINUE_BUTTON_CLICKED = 'idverify.average_revenue_continue_button.clicked',
  BACK_BUTTON_CLICKED = 'idverify.back_button.clicked',
  FINAL_LOADING_PAGE_VIEW = 'idverify.final_loading_page.view',
  UPLOAD_COMPANY_FORMATION_DOCUMENT_PAGE_VIEW = 'idverify.upload_company_formation_document_page.view',
  ACCOUNT_ADMINISTRATOR_PAGE_VIEW = 'idverify.account_administrator_page.view',
  HAS_PARTNERS_CLICKED = 'idverify.has_partners.clicked',
  DOCUMENTS_TYPE_BUTTON_CLICKED = 'idverify.documents_type_button.clicked',
  PARTNER_PROFILE_BUTTON_CLICKED = 'idverify.partner_profile_button.clicked',
  CONFIRMED_NO_PARTNER_PAGE_VIEW = 'idverify.confirmed_no_partner_page.view',
  CONFIRMED_PARTNER_PAGE_VIEW = 'idverify.confirm_partner_page.view',
}

export const EVENT_CONFIG: Record<(typeof EVENT)[keyof typeof EVENT], EventConfig> = {
  [EVENT.KNOW_HOW_TO_GET_BUTTON_VIEW]: {
    eventName: EVENT.KNOW_HOW_TO_GET_BUTTON_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.KNOW_HOW_TO_GET_BUTTON_CLICKED]: {
    eventName: EVENT.KNOW_HOW_TO_GET_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.START_REGISTRATION_BUTTON_CLICKED]: {
    eventName: EVENT.START_REGISTRATION_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.START_REGISTRATION_PAGE_VIEW]: {
    eventName: EVENT.START_REGISTRATION_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.QRCODE_PAGE_OPENED_VIEW]: {
    eventName: EVENT.QRCODE_PAGE_OPENED_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.START_QRCODE_VIEW]: {
    eventName: EVENT.START_QRCODE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.FIRST_STEP_ERROR_VIEW]: {
    eventName: EVENT.FIRST_STEP_ERROR_VIEW,
    eventScreen: 'idverify',
    eventType: 'error',
  },
  [EVENT.START_FACIAL_RECOGNITION_PAGE_VIEW]: {
    eventName: EVENT.START_FACIAL_RECOGNITION_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.START_FIRST_STEP_BUTTON_CLICKED]: {
    eventName: EVENT.START_FIRST_STEP_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.NO_ACCESS_CAMERA_BUTTON_CLICKED]: {
    eventName: EVENT.NO_ACCESS_CAMERA_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.CLOSE_MODAL_BUTTON_CLICKED]: {
    eventName: EVENT.CLOSE_MODAL_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.DOCUMENTS_REGISTRATION_PAGE_VIEW]: {
    eventName: EVENT.DOCUMENTS_REGISTRATION_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.REGISTRATION_COMPLETED_SUCCESSFULLY_PAGE_VIEW]: {
    eventName: EVENT.REGISTRATION_COMPLETED_SUCCESSFULLY_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.REGISTRATION_COMPLETED_SUCCESSFULLY_DESKTOP_PAGE_VIEW]: {
    eventName: EVENT.REGISTRATION_COMPLETED_SUCCESSFULLY_DESKTOP_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.CONSULT_DOCUMENT_ANALYSIS_PAGE_VIEW]: {
    eventName: EVENT.CONSULT_DOCUMENT_ANALYSIS_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.CONSULT_DOCUMENT_APPROVED_PAGE_VIEW]: {
    eventName: EVENT.CONSULT_DOCUMENT_APPROVED_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.CONSULT_DOCUMENT_DECLINED_PAGE_VIEW]: {
    eventName: EVENT.CONSULT_DOCUMENT_DECLINED_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.REGISTER_BANK_ACCOUNT_BUTTON_CLICKED]: {
    eventName: EVENT.REGISTER_BANK_ACCOUNT_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.REGISTER_DOCUMENTS_AGAIN_BUTTON_CLICKED]: {
    eventName: EVENT.REGISTER_DOCUMENTS_AGAIN_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.INVALID_DOCUMENT_ERROR_PAGE_VIEW]: {
    eventName: EVENT.INVALID_DOCUMENT_ERROR_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'error',
  },
  [EVENT.TRY_AGAIN_BUTTON_CLICKED]: {
    eventName: EVENT.TRY_AGAIN_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.FACIAL_RECOGNITION_SUCCESS_PAGE_VIEW]: {
    eventName: EVENT.FACIAL_RECOGNITION_SUCCESS_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.DOCUMENT_SENT_SUCCESSFULLY_PAGE_VIEW]: {
    eventName: EVENT.DOCUMENT_SENT_SUCCESSFULLY_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.TIME_EXPIRED_VIEW]: {
    eventName: EVENT.TIME_EXPIRED_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.SESSION_EXPIRED_VIEW]: {
    eventName: EVENT.SESSION_EXPIRED_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.LINK_OPEN_ON_MOBILE_CLICKED]: {
    eventName: EVENT.LINK_OPEN_ON_MOBILE_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.QRCODE_REGENERATED]: {
    eventName: EVENT.QRCODE_REGENERATED,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.FINISH_FLOW_REVIEW_SUCCESSFULLY_CLICK]: {
    eventName: EVENT.FINISH_FLOW_REVIEW_SUCCESSFULLY_CLICK,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.FACE_RECOGNITION_ERROR]: {
    eventName: EVENT.FACE_RECOGNITION_ERROR,
    eventScreen: 'idverify',
    eventType: 'error',
  },
  [EVENT.CAMERA_PERMISSION_ERROR]: {
    eventName: EVENT.CAMERA_PERMISSION_ERROR,
    eventScreen: 'idverify',
    eventType: 'error',
  },
  [EVENT.DOCUMENT_UPLOAD_ERROR]: {
    eventName: EVENT.DOCUMENT_UPLOAD_ERROR,
    eventScreen: 'idverify',
    eventType: 'error',
  },
  [EVENT.NETWORK_ERROR]: {
    eventName: EVENT.NETWORK_ERROR,
    eventScreen: 'idverify',
    eventType: 'error',
  },
  [EVENT.SDK_INITIALIZATION_ERROR]: {
    eventName: EVENT.SDK_INITIALIZATION_ERROR,
    eventScreen: 'idverify',
    eventType: 'error',
  },
  [EVENT.DOCUMENT_VALIDATION_ERROR]: {
    eventName: EVENT.DOCUMENT_VALIDATION_ERROR,
    eventScreen: 'idverify',
    eventType: 'error',
  },
  [EVENT.FACE_LIVENESS_ERROR]: {
    eventName: EVENT.FACE_LIVENESS_ERROR,
    eventScreen: 'idverify',
    eventType: 'error',
  },
  [EVENT.DOCUMENT_QUALITY_ERROR]: {
    eventName: EVENT.DOCUMENT_QUALITY_ERROR,
    eventScreen: 'idverify',
    eventType: 'error',
  },
  [EVENT.NOTIFICATION_TRY_AGAIN_VIEW]: {
    eventName: EVENT.NOTIFICATION_TRY_AGAIN_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.NOTIFICATION_OCR_ERROR_VIEW]: {
    eventName: EVENT.NOTIFICATION_OCR_ERROR_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.NOTIFICATION_AUTHORIZATION_VIEW]: {
    eventName: EVENT.NOTIFICATION_AUTHORIZATION_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.NOTIFICATION_ERROR_RETRY_CLICK]: {
    eventName: EVENT.NOTIFICATION_ERROR_RETRY_CLICK,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.SOCIAL_DOCUMENT_UPLOAD_BUTTON_CLICKED]: {
    eventName: EVENT.SOCIAL_DOCUMENT_UPLOAD_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.COMPANY_DOCUMENT_UPLOAD_BUTTON_CLICKED]: {
    eventName: EVENT.COMPANY_DOCUMENT_UPLOAD_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.CNH_DOCUMENT_UPLOAD_BUTTON_CLICKED]: {
    eventName: EVENT.CNH_DOCUMENT_UPLOAD_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.RG_DOCUMENT_UPLOAD_BUTTON_CLICKED]: {
    eventName: EVENT.RG_DOCUMENT_UPLOAD_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.RNM_RNE_DOCUMENT_UPLOAD_BUTTON_CLICKED]: {
    eventName: EVENT.RNM_RNE_DOCUMENT_UPLOAD_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.PASSPORT_DOCUMENT_UPLOAD_BUTTON_CLICKED]: {
    eventName: EVENT.PASSPORT_DOCUMENT_UPLOAD_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.DOCUMENT_UPLOAD_BUTTON_CLICKED]: {
    eventName: EVENT.DOCUMENT_UPLOAD_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.SOCIAL_CONTRACT_PAGE_VIEW]: {
    eventName: EVENT.SOCIAL_CONTRACT_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.CONTINUE_BUTTON_CLICKED]: {
    eventName: EVENT.CONTINUE_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.SAVE_AND_CONTINUE_LATER_BUTTON_CLICKED]: {
    eventName: EVENT.SAVE_AND_CONTINUE_LATER_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.SAVE_AND_CONTINUE_LATER_BUTTON_CLICKED_PAGE_VIEW]: {
    eventName: EVENT.SAVE_AND_CONTINUE_LATER_BUTTON_CLICKED_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.ADMINISTRATOR_PAGE_VIEW]: {
    eventName: EVENT.ADMINISTRATOR_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.ADMIN_SELECTED_BUTTON_CLICKED]: {
    eventName: EVENT.ADMIN_SELECTED_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.SAVE_AND_CONTINUE_LATER_BUTTON_CANCELLED_CLICKED]: {
    eventName: EVENT.SAVE_AND_CONTINUE_LATER_BUTTON_CANCELLED_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.PARTNERS_PAGE_VIEW]: {
    eventName: EVENT.PARTNERS_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.ADMIN_TAG_HOVERED]: {
    eventName: EVENT.ADMIN_TAG_HOVERED,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.PARTNERS_ADMIN_CONTAINER_CLICKED]: {
    eventName: EVENT.PARTNERS_ADMIN_CONTAINER_CLICKED,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.PARTNERS_DOCUMENTS_BUTTON_CLICKED]: {
    eventName: EVENT.PARTNERS_DOCUMENTS_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.AVERAGE_REVENUE_PAGE_VIEW]: {
    eventName: EVENT.AVERAGE_REVENUE_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.AVERAGE_REVENUE_SELECTED_BUTTON_CLICKED]: {
    eventName: EVENT.AVERAGE_REVENUE_SELECTED_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.AVERAGE_REVENUE_CONTINUE_BUTTON_CLICKED]: {
    eventName: EVENT.AVERAGE_REVENUE_CONTINUE_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.BACK_BUTTON_CLICKED]: {
    eventName: EVENT.BACK_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.FINAL_LOADING_PAGE_VIEW]: {
    eventName: EVENT.FINAL_LOADING_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.UPLOAD_COMPANY_FORMATION_DOCUMENT_PAGE_VIEW]: {
    eventName: EVENT.UPLOAD_COMPANY_FORMATION_DOCUMENT_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.ACCOUNT_ADMINISTRATOR_PAGE_VIEW]: {
    eventName: EVENT.ACCOUNT_ADMINISTRATOR_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.HAS_PARTNERS_CLICKED]: {
    eventName: EVENT.HAS_PARTNERS_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.DOCUMENTS_TYPE_BUTTON_CLICKED]: {
    eventName: EVENT.DOCUMENTS_TYPE_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.PARTNER_PROFILE_BUTTON_CLICKED]: {
    eventName: EVENT.PARTNER_PROFILE_BUTTON_CLICKED,
    eventScreen: 'idverify',
    eventType: 'click',
  },
  [EVENT.CONFIRMED_NO_PARTNER_PAGE_VIEW]: {
    eventName: EVENT.CONFIRMED_NO_PARTNER_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
  [EVENT.CONFIRMED_PARTNER_PAGE_VIEW]: {
    eventName: EVENT.CONFIRMED_PARTNER_PAGE_VIEW,
    eventScreen: 'idverify',
    eventType: 'view',
  },
};

export type EventKey = (typeof EVENT)[keyof typeof EVENT];
